module.exports = __webpack_public_path__ + "static/media/released_active.8800f572.svg";